import React, { useCallback, useMemo, useState } from 'react'
import cn from 'classnames'
import { ButtonBase } from '@material-ui/core'
import styles from './Navbar.module.scss'

import { ReactComponent as HamburgerIcon } from '../assets/icons/hamburger.svg'

import NavMenu from './NavMenu'

import NetworkIndicator from '../containers/NetworkIndicator'
import RevenueCenterTitle from '../components/RevenueCenterTitle'
import { getIsSyncing } from '../VNSyncManager/Selectors'
import { setSyncWarningDialog } from '../VNDialogs/ActionCreators'
import { useDispatch, useSelector } from 'react-redux'

import VNConfirmVersionUpdateButton from '../VNUpdateManager/components/VNConfirmVersionUpdateButton'
import { isE700Device } from '../VNAndroidSDK/Utils'

const Navbar = ({ className }) => {
  const dispatch = useDispatch()
  const [menuActive, setMenuActive] = useState(false)
  const classNames = cn(styles.navbar, className)
  const isSyncInProgress = useSelector(getIsSyncing)

  const hamburgerIcon = useMemo(() => <HamburgerIcon className={styles.hamburgerIcon} />, [])
  const toggleMenuActive = useCallback(() => setMenuActive(!menuActive), [menuActive])
  const onHamburgerClick = useCallback(() => {
    if (isSyncInProgress) {
      dispatch(setSyncWarningDialog(true, toggleMenuActive))
      return
    }

    toggleMenuActive()
  }, [isSyncInProgress, dispatch, toggleMenuActive])

  return (
    <div className={classNames}>
      {menuActive && <NavMenu onToggle={onHamburgerClick} />}

      <div className={styles.contentLeft}>
        <ButtonBase disableRipple={isE700Device()} component="div" className={styles.iconContainer} onClick={toggleMenuActive}>
          {hamburgerIcon}
        </ButtonBase>
        <VNConfirmVersionUpdateButton />
      </div>
      <div className={styles.revenueCenterName}>
        <RevenueCenterTitle className={styles.title} />
      </div>

      <div className={styles.contentRight}>
        <NetworkIndicator className={styles.indicator} />
      </div>
    </div>
  )
}

export default Navbar
